import styled from 'styled-components';

export const ListItemWrapper = styled.div`
  display: flex;
  padding: 12px 8px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black3};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.black1};
  }
`;

export const AvatarWrapper = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
`;

export const NameWrapper = styled.span`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  text-overflow: ellipsis;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0 0;
`;
